import React, { PropsWithChildren } from 'react';
import { Button, FormGroup, FormControlLabel, Switch, Paper } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Nullable } from 'global';
import { checkIfTabIsStandard } from 'modules/vendorOpportunity/list/lib';
import { TableFilter } from '@trnsact/trnsact-shared-types';

interface Props {
  currentTabValue: string;
  defaultFilter?: Nullable<TableFilter>;
  isSetDefaultTableFilterLoading: boolean;
  onFiltersClick: () => void;
  onSetAsDefaultClick: () => void;
  filtersAmount: number;
}

export const TabsWrapper = ({
  currentTabValue,
  defaultFilter,
  isSetDefaultTableFilterLoading,
  onFiltersClick,
  onSetAsDefaultClick,
  children,
  filtersAmount,
}: PropsWithChildren<Props>) => {
  const isCurrentTabDefault = defaultFilter?.tableFilterId === currentTabValue;
  const isCurrentTabIsStandard = checkIfTabIsStandard(currentTabValue);

  return (
    <Paper elevation={0} sx={{ display: 'flex', alignItems: 'center' }}>
      <Button
        startIcon={<FilterListIcon />}
        sx={{ marginRight: '1rem', whiteSpace: 'nowrap' }}
        onClick={onFiltersClick}
      >
        {`Filters ${filtersAmount}`}
      </Button>
      {children}
      {!isCurrentTabIsStandard && (
        <FormGroup sx={{ marginLeft: 'auto' }}>
          <FormControlLabel
            control={
              <Switch
                onClick={onSetAsDefaultClick}
                checked={isCurrentTabDefault}
                disabled={isSetDefaultTableFilterLoading}
              />
            }
            label="Set as Default Tab"
          />
        </FormGroup>
      )}
    </Paper>
  );
};
